/**
 * The one place the opening animation is chosen.
 *
 * Both overlays carry the same props and the same three-beat contract, so the switch is a render
 * and nothing else — no state travels across it, and the caller (Home, or the preferences
 * screen's demo button) mounts at most one at a time, which is what keeps the `sg-` filter ids
 * unique in the document.
 *
 * It read *all three* until **D218** withdrew D215's `car`; the switch is exhaustive over
 * `OpenAnimationStyle`, so a member added or removed there fails here at typecheck rather than
 * falling through to a blank overlay.
 */
import { GateOpenOverlay, type GateOpenOutcome } from './GateOpenOverlay'
import { CheckOpenOverlay } from './CheckOpenOverlay'
import type { OpenAnimationStyle } from '../../theme/openAnimation'

export interface OpenAnimationProps {
  readonly style: OpenAnimationStyle
  readonly outcome: GateOpenOutcome
  readonly onDone: () => void
}

export function OpenAnimation({ style, outcome, onDone }: OpenAnimationProps): JSX.Element {
  switch (style) {
    case 'gate':
      return <GateOpenOverlay outcome={outcome} onDone={onDone} />
    case 'check':
      return <CheckOpenOverlay outcome={outcome} onDone={onDone} />
  }
}
